module.exports = __webpack_public_path__ + "img/share.0a026828.png";